import { PersonModel } from '@utmost.co/enterprise-models';
import { useDarkly } from 'integrations/launchDarkly/legacy/useDarkly';

type Fit = 'CONTAIN' | 'COVER' | 'FILL' | 'SCALE_DOWN';
interface Props {
  url: string;
  width: number;
  height: number;
  fit: Fit;
}

const imageResizerPath = 'https://api.euw2.services.beeline.com/imageresizer/images';

const imageResizer = (props: Props): string => {
  const { imageResizer } = useDarkly();
  if (!imageResizer || !props.url) {
    return props.url;
  }

  if (props.url.startsWith(imageResizerPath)) {
    return props.url;
  }

  const encodedUrl = encodeURIComponent(props.url);
  const imageResizerUrl = `${imageResizerPath}?url=${encodedUrl}&width=${props.width}&height=${props.height}&fit=${props.fit}`;

  return imageResizerUrl;
};

interface UpdateProps<A> {
  model: A;
  width: number;
  height: number;
  fit: Fit;
}

const imageResizerUpdate = <A>(
  props: UpdateProps<A>,
  read: (model: A) => string | undefined,
  write: (src: string) => A
): A => {
  const url = read(props.model);
  const resizedUrl = imageResizer({
    url: url || '',
    width: props.width,
    height: props.height,
    fit: props.fit
  });
  return write(resizedUrl);
};

export const imageResizerUpdatePersonModelProfilePhotoSignedUrl = <
  A extends DeepPartial<PersonModel> | Pick<PersonModel, 'profilePhoto'>
>(
  props: UpdateProps<A>
) =>
  imageResizerUpdate(
    props,
    (model) => model?.profilePhoto?.signedUrl,
    (src) => ({ ...props?.model, profilePhoto: { ...(props?.model?.profilePhoto ?? {}), signedUrl: src } })
  );
